import { Routes } from '@angular/router';
import { RoleGuard, roleRedirectGuard } from '~/core/guards/role.guard';
import { UserRole } from '~/core/services/role.service';

export const routes: Routes = [
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./pages/unauthorized/unauthorized.component').then(
        (m) => m.UnauthorizedComponent,
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    canActivate: [roleRedirectGuard],
    loadComponent: () =>
      import('./pages/landing-selector/landing-selector.component').then(
        (m) => m.LandingSelectorComponent,
      ),
  },
  {
    path: 'selection',
    loadComponent: () =>
      import('./pages/landing-selector/landing-selector.component').then(
        (m) => m.LandingSelectorComponent,
      ),
    canActivate: [RoleGuard],
    data: { requiredRoles: [UserRole.USER, UserRole.ADMIN] },
  },
  {
    path: 'sme-dashboard',
    loadComponent: () =>
      import('./pages/sme-dashboard/sme-dashboard.component').then(
        (m) => m.SmeDashboardComponent,
      ),
    canActivate: [RoleGuard],
    data: { requiredRoles: [UserRole.SME, UserRole.ADMIN] },
  },
  // Manage Communications
  {
    path: 'manage-communications/localization-form',
    loadComponent: () =>
      import('./pages/manage-communications/localization-form/localization-form.component').then(
        (m) => m.LocalizationFormComponent,
      ),
    canActivate: [RoleGuard],
    data: { requiredRoles: [UserRole.USER, UserRole.ADMIN] },
  },
  {
    path: 'manage-communications/variable-form',
    loadComponent: () =>
      import('./pages/manage-communications/variable-form/variable-form.component').then(
        (m) => m.VariableFormComponent,
      ),
    canActivate: [RoleGuard],
    data: { requiredRoles: [UserRole.SME, UserRole.GM, UserRole.ADMIN] },
  },
  // Alarm Management
  {
    path: 'alarm-management/localization-form',
    loadComponent: () =>
      import('./pages/alarm-management/localization-form/alarm-form.component').then(
        (m) => m.AlarmFormComponent,
      ),
    canActivate: [RoleGuard],
    data: { requiredRoles: [UserRole.USER, UserRole.ADMIN] },
  },
  {
    path: 'alarm-management/variable-form',
    loadComponent: () =>
      import('./pages/alarm-management/variable-form/alarm-variable-editor.component').then(
        (m) => m.AlarmVariableEditorComponent,
      ),
    canActivate: [RoleGuard],
    data: { requiredRoles: [UserRole.SME, UserRole.GM, UserRole.ADMIN] },
  },
  // Operation Procedure
  {
    path: 'operation-procedure/localization-form',
    loadComponent: () =>
      import('./pages/operation-procedure/localization-form/op-proc-localization-form.component').then(
        (m) => m.OpProcLocalizationFormComponent,
      ),
    canActivate: [RoleGuard],
    data: { requiredRoles: [UserRole.USER, UserRole.ADMIN] },
  },
  {
    path: 'operation-procedure/variable-form',
    loadComponent: () =>
      import('./pages/operation-procedure/variable-form/op-proc-variable-form.component').then(
        (m) => m.OpProcVariableFormComponent,
      ),
    canActivate: [RoleGuard],
    data: { requiredRoles: [UserRole.SME, UserRole.GM, UserRole.ADMIN] },
  },
  // Operation Routine Duties
  {
    path: 'operation-routine-duties/localization-form',
    loadComponent: () =>
      import('./pages/operation-routine-duties/localization-form/ords-localization-form.component').then(
        (m) => m.OrdsLocalizationFormComponent,
      ),
    canActivate: [RoleGuard],
    data: { requiredRoles: [UserRole.USER, UserRole.ADMIN] },
  },
  {
    path: 'operation-routine-duties/variable-form',
    loadComponent: () =>
      import('./pages/operation-routine-duties/variable-form/ords-variable-form.component').then(
        (m) => m.OrdsVariableFormComponent,
      ),
    canActivate: [RoleGuard],
    data: { requiredRoles: [UserRole.SME, UserRole.GM, UserRole.ADMIN] },
  },
  {
    path: 'gm-dashboard',
    loadComponent: () =>
      import('./pages/gm-dashboard/gm-dashboard/gm-dashboard.component').then(
        (m) => m.GmDashboardComponent,
      ),
    canActivate: [RoleGuard],
    data: { requiredRoles: [UserRole.GM, UserRole.ADMIN] },
  },
  { path: '**', redirectTo: '' },
];
